import ESTIMATE_CONSTANT from "../../constant/estimateConstant"
import type EstimateValues from "../../types/params"
import getConstantByValue from "../constant/getConstantByValue"
import getNumberOfLayers from "../getNumberOfLayers"

const resolveResistPrintSideName = (value: string, { layer }: Pick<EstimateValues, "layer">) => {
  const numberOfLayers = getNumberOfLayers({ layer })
  const isOneLayer = numberOfLayers === 1

  switch (value) {
    case ESTIMATE_CONSTANT.塗布する面["パターン面と同じ面に塗る(L1面に塗る)"].value:
      return isOneLayer ? "パターン面と同じ面に塗る" : "L1面に塗る"
    case ESTIMATE_CONSTANT.塗布する面["パターン面とは逆の面に塗る(Ln面に塗る)"].value:
      return isOneLayer ? "パターン面とは逆の面に塗る" : `L${numberOfLayers}面に塗る`
    default:
      return getConstantByValue("resistPrint", value).name
  }
}

export default resolveResistPrintSideName
